import { Icon } from "@/components";
import { useI18n } from "@/lib/i18n/i18n_provider";
import { Spacer } from "@/offering/spacer";
import classNames from "classnames";
import React from "react";
import { ListGroup, Dropdown } from "react-bootstrap";
import styles from "./gallery_mobile_filters.module.css";

interface LocationFilterListItemProps {
  value?: string;
  placeholder?: string;
  label: string;
  dropdownElement: JSX.Element;
  show?: boolean;
  onToggle?: (show: boolean) => void;
  testID?: string;
  highlightBorder?: boolean;
}

export function LocationFilterListItem(props: LocationFilterListItemProps) {
  const { fbt } = useI18n();
  const {
    value,
    placeholder = fbt("Any"),
    label,
    dropdownElement,
    show,
    onToggle,
    testID,
    highlightBorder,
  } = props;

  return (
    <ListGroup.Item
      className={`${styles.filterItem} mobile-filter-item`}
      style={{ borderColor: highlightBorder ? "var(--bs-primary)" : undefined }}
    >
      <Dropdown
        className={classNames("checkout-box-picker", styles.modalDropdown)}
        show={show}
        onToggle={onToggle}
      >
        <Dropdown.Toggle style={{ padding: 0 }}>
          <div className={styles.displayValue}>
            <div className={styles.label}>{label}</div>
            <Spacer size={8} />
            {value ? (
              <div data-testid={`${testID}-value`}>{value}</div>
            ) : (
              <div className={styles.placeholder}>{placeholder}</div>
            )}
          </div>
          <div>
            <Icon name="fi-chevron-down" color="#82808E" />
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu>{dropdownElement}</Dropdown.Menu>
      </Dropdown>
    </ListGroup.Item>
  );
}
